import { useContext } from "react";
import lodash from "lodash";
import { ContextState } from "./ContextState";

const { get, set } = lodash;

export const useAppState = <T = any>(
    statePath?: string,
    defaultValue?: T
): [T, (value: T | ((prev: T) => T), path?: string) => void] => {
    const { dispatch, state } = useContext(ContextState);

    const stateValue: T = statePath
        ? get(state, statePath, defaultValue)
        : (defaultValue as T);

    const setState = (
        value: T | ((prev: T) => T),
        path?: string
    ): void => {
        const finalPath = path || statePath;

        const newValue = finalPath
            ? typeof value === "function"
                ? (value as (prev: T) => T)(get(state, finalPath))
                : value
            : typeof value === "function"
                ? (value as (prev: T) => T)(state as T)
                : value;

        const payload = finalPath ? set({}, finalPath, newValue) : newValue;

        dispatch({
            type: "setState",
            payload,
        });
    };

    return [stateValue, setState];
};